import React, { useState, useRef, Fragment, useEffect } from "react";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { db } from "../../firebase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PersonalInformation() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [userloaded, setUserLoaded] = useState(false);
  const [user, setUser] = useState({});
  const nameRef = useRef();
  const linkRef = useRef();
  const companyRef = useRef();
  const roleRef = useRef();
  const bioRef = useRef();
  const linkedinRef = useRef();
  const githubRef = useRef();

  useEffect(() => {
    let authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const fetchUserData = async () => {
      return await db
        .collection("mentors")
        .doc(currentUser.uid)
        .get()
        .then((doc) => {
          let newUserState = {
            meetLink: doc.data().meetLink,
            role: doc.data().role,
            company: doc.data().company,
            bio: doc.data().bio,
            github: doc.data().github,
          };
          setUser(newUserState);
          setUserLoaded(true);
        });
    };

    if (authUser) {
      setUser(authUser);
      setUserLoaded(true);
    } else {
      fetchUserData();
    }
  }, [currentUser]);

  async function updateData(e) {
    e.preventDefault();

    try {
      setError("");
      const payload = {
        name: nameRef.current.value,
        meetLink: linkRef.current.value,
        role: roleRef.current.value,
        bio: bioRef.current.value,
        company: companyRef.current.value,
        linkedin: linkedinRef.current.value,
        github: githubRef.current.value,
      };
      await db.collection("mentors").doc(currentUser.uid).update(payload);
      currentUser.updateProfile({
        displayName: nameRef.current.value,
      });
      user.name = nameRef.current.value;
      user.meetLink = linkRef.current.value;
      user.role = roleRef.current.value;
      user.bio = bioRef.current.value;
      user.company = companyRef.current.value;
      user.linkedin = linkedinRef.current.value;
      user.github = githubRef.current.value;
      sessionStorage.setItem("authUser", JSON.stringify(user));
      toast.success("Updated successfully");
      setLoading(true);
    } catch {
      toast.error("Unable to update right now!");
    }
  }

  const handleChange = () => {
    loading ? setLoading(false) : setLoading(true);
  };

  return (
    <>
      <Header />
      <div className="container mx-auto sm:py-24 sm:px-2 ">
        <div className="mt-10 sm:-mt-12">
          <div className="md:grid md:grid-cols-1 md:gap-6">
            <div className="md:col-span-1">
              <div className="px-4 sm:px-0">
                <h3 className="text-lg font-medium max-w-prose text-gray-500">
                  <Link to="/mentor/dashboard">Account</Link> &nbsp; &gt; &nbsp;
                  Personal information
                </h3>
                <h3 className="text-3xl mt-4 font-bold leading-relaxed text-gray-900">
                  Personal Information
                </h3>
                <p className="mt-1 text-sm text-gray-600">
                  Update your personal information here.
                </p>
              </div>
            </div>
            {error && (
              <p className="bg-red-200 p-2 text-red-700 text-sm rounded-lg">
                {error}
              </p>
            )}
            <div className="mt-5 md:mt-0 md:col-span-2">
              <form>
                <div className="overflow-hidden sm:rounded-md">
                  {loading && (
                    <div className=" bg-white p-4 sm:p-0">
                      <div className=" grid grid-cols-6 gap-6">
                        <div className=" col-span-6 sm:col-span-3 p-4 sm:p-0">
                          <div className="flex justify-between ">
                            <div>
                              <label
                                htmlFor="first_name"
                                className="outline-none text-sm font-medium text-gray-700 border-none"
                              >
                                Name
                              </label>
                            </div>

                            <div>
                              <button
                                className="text-blue-700"
                                onClick={handleChange}
                              >
                                Edit
                              </button>
                            </div>
                          </div>

                          <div>
                            <input
                              type="text"
                              value={currentUser.displayName}
                              disabled={loading}
                              className=" border-none text-gray-500 sm:text-lg -ml-3"
                            />
                          </div>
                          <div className="h-0.5 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="outline-none text-sm font-medium text-gray-700 border-none"
                            >
                              About me
                            </label>
                            {!userloaded && (
                              <div className="py-2 mb-1 bg-gray-300 rounded w-1/2 mt-2 animate-pulse"></div>
                            )}

                            {userloaded && (
                              <div className="flex flex-wrap">
                                <p className="mt-1 border-none text-gray-500 w-full sm:text-lg">
                                  {user.bio}
                                </p>
                              </div>
                            )}
                            <div className="h-0.5 bg-gray-300 rounded"></div>
                          </div>
                        </div>
                      </div>

                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="outline-none text-sm font-medium text-gray-700 border-none"
                            >
                              Linkedin Profile
                            </label>
                            {!userloaded && (
                              <div className="py-2 mb-1 bg-gray-300 rounded w-1/2 mt-2 animate-pulse"></div>
                            )}

                            {userloaded && (
                              <input
                                type="text"
                                name="name"
                                disabled={loading}
                                id="name"
                                defaultValue={user.linkedin}
                                className="mt-1 border-none text-gray-500 w-full -ml-3 sm:text-lg"
                              />
                            )}
                            <div className="h-0.5 bg-gray-300 rounded"></div>
                          </div>
                        </div>
                      </div>

                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="outline-none text-sm font-medium text-gray-700 border-none"
                            >
                              Calendly Link
                            </label>
                            {!userloaded && (
                              <div className="py-2 mb-1 bg-gray-300 rounded w-1/2 mt-2 animate-pulse"></div>
                            )}

                            {userloaded && (
                              <input
                                type="text"
                                name="name"
                                disabled={loading}
                                id="name"
                                defaultValue={user.meetLink}
                                className="mt-1 border-none text-gray-500 w-full -ml-3 sm:text-lg"
                              />
                            )}
                            <div className="h-0.5 bg-gray-300 rounded"></div>
                          </div>
                        </div>
                      </div>

                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="outline-none text-sm font-medium text-gray-700 border-none"
                            >
                              GitHub Profile
                            </label>
                            {!userloaded && (
                              <div className="py-2 mb-1 bg-gray-300 rounded w-1/2 mt-2 animate-pulse"></div>
                            )}

                            {userloaded && user.github ? (
                              <input
                                type="text"
                                name="name"
                                disabled={loading}
                                id="name"
                                defaultValue={user.github}
                                className="mt-1 border-none text-gray-500 w-full -ml-3 sm:text-lg"
                              />
                            ) : (
                              <input
                                type="text"
                                name="name"
                                disabled={loading}
                                id="name"
                                defaultValue="N/A"
                                className="mt-1 border-none text-gray-500 w-full -ml-3 sm:text-lg"
                              />
                            )}
                            <div className="h-0.5 bg-gray-300 rounded"></div>
                          </div>
                        </div>
                      </div>

                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="outline-none text-sm font-medium text-gray-700 border-none"
                            >
                              Company
                            </label>
                            {!userloaded && (
                              <div className="py-2 mb-1 bg-gray-300 rounded w-1/3 mt-2 animate-pulse"></div>
                            )}

                            {userloaded && (
                              <input
                                type="text"
                                name="name"
                                id="name"
                                disabled={loading}
                                defaultValue={user.company}
                                className="mt-1 border-none text-gray-500 w-full -ml-3 sm:text-lg"
                              />
                            )}
                            <div className="h-0.5 bg-gray-300 rounded"></div>
                          </div>
                        </div>
                      </div>
                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="outline-none text-sm font-medium text-gray-700 border-none"
                            >
                              Role
                            </label>
                            {!userloaded && (
                              <div className="py-2 bg-gray-300 mb-1 rounded w-1/3 mt-2 animate-pulse"></div>
                            )}

                            {userloaded && (
                              <input
                                type="text"
                                name="name"
                                id="name"
                                disabled={loading}
                                defaultValue={user.role}
                                className="mt-1 border-none text-gray-500 w-full -ml-3 sm:text-lg"
                              />
                            )}
                            <div className="h-0.5 bg-gray-300 rounded"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {!loading && (
                    <div>
                      <div className="bg-white p-4 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <div className="flex justify-between">
                              <label
                                htmlFor="first_name"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Name
                              </label>

                              <div>
                                <button
                                  className="text-blue-700"
                                  onClick={handleChange}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>

                            <div class="flex bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                              <input
                                class="w-full bg-gray-100 outline-none"
                                ttype="text"
                                name="name"
                                id="name"
                                ref={nameRef}
                                defaultValue={currentUser.displayName}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-700"
                            >
                              About me
                            </label>
                            <div class="w-full flex flex-wrap bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                              <textarea
                                id="bio"
                                ref={bioRef}
                                name="bio"
                                rows="4"
                                cols="50"
                                style={{
                                  overflow: "auto",
                                  outline: "none",
                                  border: "none",
                                  boxShadow: "none",
                                }}
                                className="w-full bg-gray-100 outline-none focus:outline-none"
                              >
                                {user.bio}
                              </textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Linkedin Profile
                            </label>
                            <div class="flex bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                              <input
                                ttype="text"
                                name="name"
                                id="name"
                                ref={linkedinRef}
                                defaultValue={user.linkedin}
                                class="w-full bg-gray-100 outline-none"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Calendly Link
                            </label>

                            <div class="flex bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                              <input
                                ttype="text"
                                name="name"
                                id="name"
                                disabled
                                ref={linkRef}
                                defaultValue={user.meetLink}
                                class="w-full bg-gray-100 outline-none"
                              />
                            </div>
                            <p className="text-sm text-red-400 mt-1">
                              * to change calendly link please{" "}
                              <a
                                className="underline"
                                href="mailto:hellodevcolony@gmail.com?subject=Request to change calendly meeting link"
                              >
                                contact us
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-700"
                            >
                              GitHub Profile
                            </label>

                            <div class="flex bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                              <input
                                ttype="text"
                                name="name"
                                id="name"
                                placeholder="https://github..com/username"
                                ref={githubRef}
                                defaultValue={user.github}
                                class="w-full bg-gray-100 outline-none"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Company
                            </label>
                            <div class="flex bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                              <input
                                ttype="text"
                                name="name"
                                id="name"
                                ref={companyRef}
                                defaultValue={user.company}
                                class="w-full bg-gray-100 outline-none"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=" bg-white p-4 mt-8 sm:p-0">
                        <div className="grid grid-cols-6 gap-6">
                          <div className="col-span-6 sm:col-span-3">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Role
                            </label>
                            <div class="flex bg-gray-100 p-4 w-72 space-x-4 rounded-lg mt-4">
                              <input
                                ttype="text"
                                name="name"
                                id="name"
                                ref={roleRef}
                                defaultValue={user.role}
                                class="w-full bg-gray-100 outline-none"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="px-4 py-8 text-left sm:px-0">
                        <button
                          type="submit"
                          onClick={updateData}
                          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gradient-to-r from-blue-500 to-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                          Update info
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default PersonalInformation;
